import React from 'react';
// parse {30.4101 - Environmental Geosciences: true/false} into 30.4101 and Environmental Geosciences
// return ['30.4101', 'Environmental Geosciences']
export const parserone = obj => `${Object.keys(obj)[0]}`.split(' - ');

/**
 *
  Takes an array of simple objects of n size: [{}, {}, {}, ..., n]
  Return a 1 by n, where each element is an array: [[], [], [], [], ..., n]
 */
export const dataForSelectedMajors = arr => {
  const data = [];
  arr.forEach(obj => {
    data.push([
      obj['qid'],
      [obj['name'], obj['qid']],
      [null, obj['qid']],
      [null, obj['qid']],
      [null, obj['qid']],
      [null, obj['qid']],
      [null, obj['qid']],
      [null, obj['qid']],
      obj['qid']
    ]);
  });
  data.unshift(['Delete', 'Select all degrees per column', null, null, null, null, null, null, null]);
  return data;
};

/**
 * input: takes string of type: 'id - name'
 * return: name...id
 *  - the '...' should shorten the name
 */
export const shortenName = str => {
  if(str.includes('-')) {
    const val = str.split('-');
    let res = '';
    //name less than 18 - got this from design - counted the demo
    if(val[0].length > 20) {
      res = `${val[0].substring(0, 19)} ... ${val[1]}`;
    } else {
      res = `${val[0]}-${val[1]}`;
    }
    return res;
  }
  return str;
};
//decide whether to use tooltip
export const isShortName = str => {
  if(str.includes('-')) {
    const val = str.split('-');
    if(val[0].length >= 20) {
      return true;
    } else {
      return false;
    }
  }
  return false;
};

export const DEGREES = ['Certificate', 'Associate', 'Bachelors', 'Masters', 'Doctorate', 'Teacher\'s Certificate'];

export const checkboxInputUpdate = (arr, index, qid) => {
  const res = arr.find(major => major.qid ===qid);

  if(res===undefined) {
    return null;
  } else if(res.boxChecked) {
    return res.degrees[index];
  }else {
    return null;
  }
};

export const TableHeaders = () => (
  <thead>
    <tr style={{backgroundColor: 'white'}}>
      <td className='text_values' id={`id${0}head`} key={`id${0}head`}><span class='sr-only'>Select Row</span></td>
      <td className='text_values' id={`id${1}head`} key={`id${1}head`}><span class='sr-only'>Select Row</span></td>
      <th scope='col' className='text_values' id={`id${2}head`} key={`id${2}head`}>Certificate</th>
      <th scope='col' className='text_values' id={`id${3}head`} key={`id${3}head`}>Associate</th>
      <th scope='col' className='text_values' id={`id${4}head`} key={`id${4}head`}>Bachelors</th>
      <th scope='col' className='text_values' id={`id${5}head`} key={`id${5}head`}>Masters</th>
      <th scope='col' className='text_values' id={`id${6}head`} key={`id${6}head`}>Doctorate</th>
      <th scope='col' className='text_values' id={`id${7}head`} key={`id${7}head`}>Teacher's Certificate</th>
      {/* <td className='text_values' id={`id${8}head`} key={`id${8}head`}><span class='sr-only'>Select Row</span></td> */}
    </tr>
  </thead>
);